import React, { useEffect, useState} from "react";
import { NavLink } from "react-router-dom";
import Loading from "../../images/loading2.gif";
import firebaseDb from "../../firebase";
import {  ref, child, get} from "firebase/database";



const Empleocuatro = () => {

    
    const [contactObjects, setContactObjects] = useState({}) 
    const dbRef = ref(firebaseDb);
    const [isLoading, setLoading] = useState(true)

    useEffect(() => {
       get(child(dbRef,'experiencias')).then((snapshot) => {
           if (snapshot.exists()) {
          
            
             setContactObjects({
               ...snapshot.val()
           })
 
           setLoading(false) 
          
         
            //console.log(snapshot.val());
           } else {
             setContactObjects({})
             console.log("No data available");
           }
         }).catch((error) => {
           console.error(error);
         });
 }, []);


    
return (
            <>


    <section className="education">     

 
            <div className="box-container">

                <div className="box">
                    <div className="image">
                    {isLoading 
                          ? 
                            <img src={Loading} alt="img"/>
                         
                          : (
                                
                            <div>
                            {Object.keys(contactObjects).map((key) => {
                                return (
                                      <img src={contactObjects[key].expe4} alt="img"/>
                                    );
                                  })}
                           
                            </div>
                            )
                          }
                    </div>

                    <div className="content">
                        <div className="icons">
                        
                        
                        </div>
                        <i className="fas fa-building fa-3x" aria-hidden="true"></i> 
                        <h3>BANCO DE VENEZUELA</h3>   
                                    <h3>Especialista Senior en Tecnología </h3>

                            <p>10- 2012 / 02 -2017 Caracas- Venezuela</p>
                            &nbsp;
                         
                          
             <ul>
              <li> <p>Analisar requisitos, projetos e produtos tecnológicos
                        envolvendo sistemas e aplicações com o propósito de determinar o 
                        riscos de informação
                    </p>
             </li>

             
          

            </ul>


                         
                       
                    </div>
                </div>

                
            </div>
           
            <NavLink className="btn"  to="/porta"  aria-current="page"  >
          
                Retornar
                <i className="fas fa-redo"></i>
            </NavLink>
                 

  </section>

    

                
        
        </>
        )
    }


export default Empleocuatro
